module.exports = __webpack_public_path__ + "static/we-travel-hero-072eb42d48b0ad9111bafe06c1114cef.jpg";